import { v4 as uuidv4 } from 'uuid'
import { getEnvConfig } from 'utils/getEnvConfig'
import {
  ICreateBusinessChargeAction,
  ICreateBusinessDiscountAction,
  IFetchBillsRequestPayload,
  IQuotationRequestPayload,
  IRequestPayload,
  InventoryItemUploadType
} from 'state/billing/billing.types'
import ApiService from '../ApiService'
import {
  apiRequestInterceptor,
  businessIdInterceptor,
  apiResponseSuccessInterceptor,
  apiResponseErrorInterceptor
} from '../apiInterceptor'
import { IApiResponse, API_RESPONSE_TYPE } from '../../../constants'
import {
  BillByIdResponse,
  CREATE_BILL_RESPONSE,
  FETCH_BILL_RESPONSE,
  INVENTORY_ITEMS_OPERATION_REQUEST_PAYLOAD,
  INVENTORY_ITEM_REQUEST_TYPE,
  INVENTORY_OPERATION_TYPE,
  FETCH_BUSINESS_DISCOUNTS_RESPONSE,
  ITEMS_OPERATION_REQUEST_PAYLOAD,
  ITEMS_OPERATION_RESPONSE_TYPE,
  InventoryItemLogsResponseType,
  InventoryItemsResponseType,
  OPERATION_TYPE,
  PAYLOAD_ITEMS_TYPE,
  FETCH_BUSINESS_CHARGES_RESPONSE,
  FETCH_QUOTATIONS_RESPONSE,
  CREATE_QUOTATION_RESPONSE,
  QuotationByIdResponse,
  FETCH_PURCHASE_BILL_RESPONSE,
  // FETCH_INVENTORY_CATEGORY_TAGS_RES,
  IBusinessSettingPayload,
  IBusinessSettingsResponse
} from './type'

const FETCH_ALL_ITEMS = '/web/stock/v1/list-catalog'
const CATALOGUE_ITEM_OPERATIONS = '/web/stock/v1/sync-catalog-operations'
const INVENTORY_ITEM_OPERATIONS = 'web/stock/v1/sync-inventory-operation'
const UPLOAD_INVENTORY_ITEMS = '/web/stock/v1/inventory-upload'
const UPLOAD_BILL = '/web/v3/bill'
const UPLOAD_QUOTATION = '/web/v1/create-quotation'
const FETCH_SALES_BILLS = '/web/v3/fetch-sale-bills'
const FETCH_QUOTATIONS = '/web/v1/list-quotations'
const SHARE_BILLING_FEEDBACK = '/web/v1/feedback'
const FETCH_BILL_BY_ID = '/web/v1/bill'
const FETCH_QUOTATION_BY_ID = '/web/v1/quote'
const UPDATE_BILL_BY_ID = '/web/v1/update-bill'
const UPDATE_QUOTAION_BY_ID = '/web/v1/update-quotation'
const FETCH_INVENTORY_UNIT = 'web/stock/v1/business-catalog-units'
const FETCH_INVENTORY_ITEM_OFFER = '/web/stock/v1/list-offer'
const INVENTORY_ITEM_LOGS = '/web/stock/v2/inventory-item-logs'
const FETCH_DISCOUNTS = 'web/v1/business-bill-discounts'
const CREATE_BUSINESS_DISCOUNT = 'web/v1/business-bill-discount'
const FETCH_CHARGES = 'web/v1/business-bill-charges'
const CREATE_BUSINESS_CHARGE = 'web/v1/business-bill-charge'
const CREATE_CREDIT_NOTE = 'web/v1/credit-note'
const CREATE_OFFER = 'web/stock/v1/create-offer'
const APPLY_OFFER = 'web/stock/v1/inventory-offer-map'
const REMOVE_OFFER = 'web/stock/v1/remove-inventory-offer-map'
const DELETE_OFFER = 'web/stock/v1/delete-offers'
const CREATE_CATALOG_UNIT = 'web/stock/v1/create-catalog-unit'
const FETCH_CREDIT_NOTES = '/web/v1/get-credit-notes'
const FETCH_PURCHASE_BILL = '/web/v1/list-purchase-bill'
const DELETE_CREDIT_NOTE = '/web/v1/sync-delete-credit-note-operations'
const SETTLE_CREDIT_NOTE = '/web/v1/settle-bill-by-credit-note'
const GET_BUSINESS_SETTINGS = '/unauth/v1/business-settings'
const BULK_DELETE_ITEMS = '/web/stock/v1/bulk-delete-inventory'
// const FETCH_CATEGORY_TAGS = '/web/stock/v1/business-inventory-tags'
const CONVERT_QUOTATION_TO_INVOICE = '/web/v1/quotation-to-bill'

// Business related
const GET_OVERALL_BUSINESS_SETTING = '/web/v1/business-settings'

const headers = {
  'content-type': 'application/json',
  accept: 'application/json, text/plain, */*'
}

const endpoint = getEnvConfig('BILLING_ENDPOINT') || ''

const api = new ApiService(endpoint, headers)

api.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
api.requestInterceptor(businessIdInterceptor, (error: any) => console.error(error))
api.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

export const fetchBusinessSettingsApi = ({ merchantId }: { merchantId: string }) => {
  return {
    data: { settings: {} as IBusinessSettingsResponse },
    type: API_RESPONSE_TYPE.SUCCESS
  }
}

export const bulkDeleteItems = ({ item_ids }: { item_ids: string[] }) => {
  return api.postRequest(`${BULK_DELETE_ITEMS}`, { item_ids })
}

export const convertQuotationToInvoice = ({
  quoteId,
  billNumber,
  billDateinMilliseconds
}: {
  quoteId: string
  billNumber: string
  billDateinMilliseconds: number
}) => {
  return api.postRequest(`${CONVERT_QUOTATION_TO_INVOICE}`, {
    quote_id: quoteId,
    bill_number: billNumber,
    bill_date: billDateinMilliseconds
  })
}

export const createCatalogUnit = (payload: { unit: string }): Promise<IApiResponse> => {
  return api.postRequest(CREATE_CATALOG_UNIT, payload)
}

export const createOffers = (payload: any) => {
  return api.postRequest(CREATE_OFFER, payload)
}

export const fetchPurchaseBillApi = (): Promise<IApiResponse<FETCH_PURCHASE_BILL_RESPONSE>> => {
  return api.getRequest(FETCH_PURCHASE_BILL, {})
}

export const applyOfferOnItem = (payload: any) => {
  return api.postRequest(APPLY_OFFER, payload)
}

export const removeOfferOnItem = (payload: { offer_id: string; inv_id: string }) => {
  return api.postRequest(REMOVE_OFFER, payload)
}

export const deleteOffer = (payload: { offer_ids: string[] }) => {
  return api.postRequest(DELETE_OFFER, payload)
}

export const fetchAllItems = () => {
  return api.getRequest(FETCH_ALL_ITEMS, {})
}

export const fetchInventoryUnitApi = (): Promise<IApiResponse<{ units: string[] }>> => {
  return api.getRequest(FETCH_INVENTORY_UNIT, {})
}

export const fetchInventoryItemsOffers = (): Promise<IApiResponse<any>> => {
  return api.getRequest(FETCH_INVENTORY_ITEM_OFFER, {})
}

export const catalogueOperations = ({
  operation,
  item
}: {
  operation: OPERATION_TYPE
  item: PAYLOAD_ITEMS_TYPE | { item_id: string }
}): Promise<IApiResponse<ITEMS_OPERATION_RESPONSE_TYPE>> => {
  const payload: ITEMS_OPERATION_REQUEST_PAYLOAD = {
    op_type: operation,
    item
  }

  return api.postRequest(CATALOGUE_ITEM_OPERATIONS, payload)
}

export const inventoryOperations = ({
  operation,
  item
}: {
  operation: INVENTORY_OPERATION_TYPE
  item: INVENTORY_ITEM_REQUEST_TYPE
}): Promise<IApiResponse<{ item: InventoryItemsResponseType }>> => {
  const payload: INVENTORY_ITEMS_OPERATION_REQUEST_PAYLOAD = {
    request_id: uuidv4(),
    op_type: operation,
    item
  }

  return api.postRequest(INVENTORY_ITEM_OPERATIONS, payload)
}

export const uploadInventoryItemsOldApi = (payload: InventoryItemUploadType['formData']) => {
  return api.postRequest(UPLOAD_INVENTORY_ITEMS, payload, {
    'Content-Type': 'multipart/form-data'
  })
}

export const uploadBill = (
  payload: IRequestPayload
): Promise<IApiResponse<CREATE_BILL_RESPONSE>> => {
  return api.postRequest(UPLOAD_BILL, payload)
}

export const uploadQuotation = (
  payload: IQuotationRequestPayload
): Promise<IApiResponse<CREATE_QUOTATION_RESPONSE>> => {
  return api.postRequest(UPLOAD_QUOTATION, payload)
}

export const fetchBillsV3 = (
  payload: IFetchBillsRequestPayload
): Promise<IApiResponse<FETCH_BILL_RESPONSE>> => {
  return api.postRequest(FETCH_SALES_BILLS, payload)
}

export const fetchQuotationsApi = (): Promise<IApiResponse<FETCH_QUOTATIONS_RESPONSE>> => {
  return api.getRequest(FETCH_QUOTATIONS, {})
}

export const fetchBusinessDiscounts = (): Promise<
  IApiResponse<FETCH_BUSINESS_DISCOUNTS_RESPONSE>
> => {
  return api.getRequest(FETCH_DISCOUNTS, {})
}

export const createBusinessDiscount = (
  payload: ICreateBusinessDiscountAction
): Promise<IApiResponse<{ success: boolean }>> => {
  return api.postRequest(CREATE_BUSINESS_DISCOUNT, payload)
}

export const fetchBusinessCharges = (): Promise<IApiResponse<FETCH_BUSINESS_CHARGES_RESPONSE>> => {
  return api.getRequest(FETCH_CHARGES, {})
}

export const createBusinessCharge = (
  payload: ICreateBusinessChargeAction
): Promise<IApiResponse<{ success: boolean }>> => {
  return api.postRequest(CREATE_BUSINESS_CHARGE, payload)
}

export const shareFeedback = (payload: string): Promise<IApiResponse<{ success: boolean }>> => {
  return api.postRequest(SHARE_BILLING_FEEDBACK, { feedback: payload })
}

export const fetchBillByIdApi = (billId: string): Promise<IApiResponse<BillByIdResponse>> => {
  return api.getRequest(`${FETCH_BILL_BY_ID}?id=${billId}`, {})
}

export const fetchQuotationByIdApi = (
  quotationId: string
): Promise<IApiResponse<QuotationByIdResponse>> => {
  return api.getRequest(`${FETCH_QUOTATION_BY_ID}?id=${quotationId}`, {})
}

export const updateBillApi = (
  payload: IRequestPayload
): Promise<IApiResponse<BillByIdResponse>> => {
  return api.postRequest(UPDATE_BILL_BY_ID, payload)
}

export const updateQuotationApi = (
  payload: IQuotationRequestPayload
): Promise<IApiResponse<QuotationByIdResponse>> => {
  return api.postRequest(UPDATE_QUOTAION_BY_ID, payload)
}

export const createCreditNoteApi = (payload: any) => {
  return api.postRequest(CREATE_CREDIT_NOTE, payload)
}

export const inventoryItemLogsApi = (
  itemId: string
): Promise<IApiResponse<InventoryItemLogsResponseType>> => {
  return api.getRequest(`${INVENTORY_ITEM_LOGS}?item_id=${itemId}`, {})
}

export const fetchCreditNoteListApi = (payload: {
  business_id: string
  filter_details: {
    page: number
    per_page: number
    sort_by?: string
    search_string?: string
    customer_ids?: string[]
  }
}): Promise<IApiResponse<any>> => {
  return api.postRequest(FETCH_CREDIT_NOTES, payload)
}

export const getStaffBusinessSettingsApi = (payload: string) => {
  const api2 = new ApiService(endpoint, headers)
  return api2.getRequest(`${GET_BUSINESS_SETTINGS}?bid=${payload}`, {})
}

export const deleteCreditNoteApi = (payload: string): Promise<IApiResponse<any>> => {
  return api.postRequest(DELETE_CREDIT_NOTE, { cn_id: payload })
}

export const settleCreditNoteApi = (payload: {
  cn_id: string
  bill_id: string
}): Promise<IApiResponse<any>> => {
  return api.postRequest(SETTLE_CREDIT_NOTE, payload)
}

// export const fetchCategoryTagsApi = (): Promise<
//   IApiResponse<FETCH_INVENTORY_CATEGORY_TAGS_RES>
// > => {
//   return api.getRequest(FETCH_CATEGORY_TAGS, {})
// }

export const fetchOverallBusinessSettingsApi = (): Promise<
  IApiResponse<{ settings: IBusinessSettingsResponse }>
> => {
  return Promise.resolve({
    data: { settings: {} as IBusinessSettingsResponse },
    type: API_RESPONSE_TYPE.SUCCESS
  })
}

export const updateBusinessSettingsApi = (
  payload: IBusinessSettingPayload
): Promise<IApiResponse<any>> => {
  return api.postRequest(GET_OVERALL_BUSINESS_SETTING, payload)
}
